import React, { useCallback, useEffect, useState } from 'react';
import { BlockUI } from 'primereact/blockui';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLanguage } from '../../../contexts/LanguageContext';
import useUnpickedPartsReportData from './hooks/useUnpickedPartsReportData';
import UnpickedPartsReportFilters from './components/UnpickedPartsReportFilters';
import UnpickedPartsReportTable from './components/UnpickedPartsReportTable';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportUnpickedPartsToExcelQuery } from '../../../api/endpoints/parts';

const UnpickedPartsReportPage = () => {
    const { th } = useLanguage();
    const { rows, totalRecords, loading, filters, lazyParams, onPage, handleApplyFilters, handleResetFilters, exportParams } = useUnpickedPartsReportData();
    const [isExporting, setIsExporting] = useState(false);

    useEffect(() => {
        const previousCursor = document.body.style.cursor;
        document.body.style.cursor = isExporting ? 'wait' : '';
        return () => {
            document.body.style.cursor = previousCursor;
        };
    }, [isExporting]);

    const handleExportStart = useCallback(() => {
        setIsExporting(true);
    }, []);

    const handleExportEnd = useCallback(() => {
        setIsExporting(false);
    }, []);

    return (
        <div className="card" style={isExporting ? { cursor: 'wait' } : undefined}>
            <BlockUI
                blocked={isExporting}
                template={
                    <div className="flex flex-column align-items-center gap-2">
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" />
                    </div>
                }
            >
                <div className="flex justify-content-between align-items-center mb-4">
                    <h1 className="m-0">{th('unpickedPartsReport.title')}</h1>
                    <GenericFileExportButton
                        useExportQuery={useLazyExportUnpickedPartsToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('unpickedPartsReport.excelExport')}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        disabled={isExporting}
                        fileNameExtractor={(result) => result?.fileName || 'unpicked-parts.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                        onExportStart={handleExportStart}
                        onExportSuccess={handleExportEnd}
                        onExportError={handleExportEnd}
                    />
                </div>

                <div className="mb-2">
                    <UnpickedPartsReportFilters filters={filters} onApplyFilters={handleApplyFilters} onReset={handleResetFilters} />
                </div>

                <UnpickedPartsReportTable items={rows} totalRecords={totalRecords} loading={loading} lazyParams={lazyParams} onPage={onPage} />
            </BlockUI>
        </div>
    );
};

export default UnpickedPartsReportPage;
